









import { mapState } from "vuex";
import Vue from "vue";

// noinspection JSUnusedGlobalSymbols
export default Vue.extend({
  name: "New",
  components: {
    VInstrumentForm: () => import("@/components/createComponents/VInstrumentForm.vue"),
    VNewNumber: () => import("@/components/createComponents/VNewNumber.vue")
  },
  computed: mapState(["newInstrumentNumber"])
});
